import SchoolsOfGroup from './SchoolsOfGroup.component';

export default SchoolsOfGroup;
